import {Component, forwardRef} from "@angular/core";
import {UserActionBaseComponent} from "../userAction-base.component";
import {UserActionFeatureSystemsComponent} from "../userAction-featureSystem/userAction-featureSystem.component";
import {LoginService} from "../../../../Services/login.service";
import {MacroService} from "../../../../Services/CatalogManagement/macro.service";
import {JobService} from "../../../../Services/job.service";
import {TranslateService} from "@ngx-translate/core";
import {CatalogService} from "../../../../Services/CatalogManagement/catalog.service";
import {ValidFeatureService} from "../../../../Services/validFeature.service";
import {SearchByListParameter} from "../../../../Model/Dto/SearchByListParameter";
import {UserActionByListComponent} from "../userAction-byList/userAction-byList.component";
import {SystemService} from "../../../../Services/system.service";
import DataSource from "devextreme/data/data_source";
import {ListoutByListParameter} from "../../../../Model/Dto/ListOutByListParameter";
import {ProductState} from "../../../../Model/Catalog/ProductState";
import {ProductStateService} from "../../../../Services/productState.service";

@Component({
  selector: 'userAction-listoutByList',
  templateUrl: 'userAction-listoutByList.component.html',
  styleUrls: ['../userActionSearchDeleteListStyle.css'],
  providers: [
    { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionListoutByListComponent) }
  ],
  standalone: false
})
export class UserActionListoutByListComponent extends UserActionByListComponent{
  

  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public productStateService: ProductStateService,
    public jobService: JobService,
    public translate: TranslateService,
    public catalogService: CatalogService,
    public systemService: SystemService
  ) {
    super(loginService, macroService);
    this.getSearchValueDisplayExpr = this.getSearchValueDisplayExpr.bind(this);
    this.getNoDataText = this.getNoDataText.bind(this);
    this.canStartMacro = this.canStartMacro.bind(this);
  }
  exportParameterSet : ListoutByListParameter;
  loadingVisible = false;
  searchValues = ['SUPPLIER_PID', 'SUPPLIER_ALT_PID', 'INTERNATIONAL_PID', 'MANUFACTURER_NAME', 'PID', 'MANUFACTURER_PID'];
  searchValue = '';
  kommaTrennzeichen: boolean = true;
  semikolonTrennzeichen: boolean = true;
  manufacturerFilters = [];
  selectedManufacturer: string[] = [];
  manufacturerDataSource: DataSource;

  public productStates: string[] = [];

  async ngOnInit() {

    this.exportParameterSet = new ListoutByListParameter();
    this.getStatus();
  }

  getStatus() {
    this.productStateService.getStatus().subscribe((result: ProductState[]) => {
      this.productStates = new Array<string>();
      result.forEach((x) => {
        this.productStates.push(x.name);
      });
    });
  }
  
  createParameterStringAsJsonString(): string {
    this.inputList = this.formatListIgnoreSpace(this.inputList, this.kommaTrennzeichen, this.semikolonTrennzeichen);
    let values = this.inputList;
    if (this.searchValue == 'MANUFACTURER_NAME')
      values = this.selectedManufacturer.join('\n');
    
    this.exportParameterSet.searchByListParameter = new SearchByListParameter(this.searchValue, values);
    return JSON.stringify(this.exportParameterSet);
  }

  public async canStartMacro(): Promise<boolean> {
    let values = this.inputList;
    if (this.searchValue == 'MANUFACTURER_NAME')
      values = this.selectedManufacturer.join('\n');
    if (values == "" && this.kommaTrennzeichen == false && this.semikolonTrennzeichen == false)  {
      this.systemService.notifyInfo(this.translate.instant('Bitte mindestens einen Wert, nach dem gesucht werden soll, eingeben'));
      return false;
    }
    return true;
  }

  getSearchValueDisplayExpr(item) {
    if (!item) {
      return '';
    }

    return this.translate.instant(item);
  }
  
  parseParameter(parameter: string) {
    if(!parameter)
      return;
    try {
      const parsed : SearchByListParameter= JSON.parse(parameter);
      this.searchValue = parsed.key;
      this.inputList = parsed.list;
      this.exportParameterSet.searchByListParameter = parsed;
    } catch (error) {
      console.error('Invalid JSON string provided:', error);
    }
  }
  
  getNoDataText() {
    if (this.loadingVisible) {
      return this.translate.instant('Daten werden geladen');
    } else {
      return this.translate.instant('keine Daten gefunden');
    }
  }
}